import { OPEN_DRAWER_PAGE, SET_FIELD_INVALID, SET_FLYOUT_VERIFIED } from 'actions';
import { ADDITIONAL_USER_INPUTS_PAGE, LOCATION_AND_LOADS_PAGE, MODULE_SELECTION_PAGE, RAIL_SYSTEM_PAGE } from 'projectDesign/components/projectConfiguration/utils/projectConfigurationDrawerPages';
import * as React from 'react';
import SVG from 'react-inlinesvg';
import { Checkbox } from 'react-md';
import Tooltip from '__common/components/Tooltip';
import { dispatch, state } from '__common/store';
import { isASCE722BuildingCode } from 'projectDesign/components/projectConfiguration/projectConfiguration';
import { disabled722BuildingCodeProducts, isAdditionalUserInputEnabledProduct, isAscender, isULA } from '__common/constants/products';
import { apiField as buildingCodeApiField } from 'projectDesign/components/projectConfiguration/fields/buildingCode';
import { ACCESS_FOR_7_22_PERMISSION } from 'user/userGroups';
import { ulaClampOptions } from 'projectDesign/components/projectConfiguration/utils/constants';
import { applyAsce722AccessForEcoFoot2Plus, applyAsce722AccessForRM10Evo } from '__common/utils/versionCompare/versionCompare';

import { apiField as clampTypeChoiceApiField } from "projectDesign/components/projectConfiguration/fields/clampTypeChoice";

type Props = {
  label?: string,
  onClick: () => void,
  page?: string
  verifiedFlyouts?: verifiedFlyouts
};

export default class SaveChangesButton extends React.Component<Props> {
  render() {
    const { label, page, verifiedFlyouts, onClick } = this.props;
    const {projectConfiguration:{projectEnvConfig, productId, projectVersion, railsProductId}, user:{permissions, isStaff}} = state();
    const isAuroraRackingTypeSM = projectEnvConfig?.aurora_racking_type && projectEnvConfig?.aurora_racking_type===9 ? true : false;
    function verifyInputs(isChecked: boolean): void {
      if (verifiedFlyouts[page]?.error) {
        return;
      }
      if (isChecked && page === RAIL_SYSTEM_PAGE && isAscender(productId) && !isAscender(railsProductId)) {
        dispatch(SET_FLYOUT_VERIFIED(RAIL_SYSTEM_PAGE, false));
        return;
      }
      if (isASCE722BuildingCode(projectEnvConfig.building_code) && !applyAsce722AccessForRM10Evo(productId, projectVersion) && !applyAsce722AccessForEcoFoot2Plus(productId, projectVersion) && !permissions.includes(ACCESS_FOR_7_22_PERMISSION) && disabled722BuildingCodeProducts(productId) && page === 'location-and-loads' ){
        dispatch(SET_FLYOUT_VERIFIED(LOCATION_AND_LOADS_PAGE, false, true));
        dispatch(SET_FIELD_INVALID(buildingCodeApiField, `Incompatible with ASCE 7-22. Please choose an appropriate building code.`));
        return;
      }
      if(isULA(productId) && projectEnvConfig.clamp_type === ulaClampOptions.PRO_SERIES && page === 'rail-system'){
        dispatch(SET_FLYOUT_VERIFIED(RAIL_SYSTEM_PAGE, false, true));
        dispatch(SET_FIELD_INVALID(clampTypeChoiceApiField, `Incompatible with PRO SERIES clamp option. Please choose an appropriate clamp option.`));
        return;
      }
      dispatch(SET_FLYOUT_VERIFIED(page, isChecked));

      if (isChecked) {
        onClick();
        const flyoutOrder = [MODULE_SELECTION_PAGE, LOCATION_AND_LOADS_PAGE, RAIL_SYSTEM_PAGE];
        if (isAdditionalUserInputEnabledProduct(productId) && isStaff) {
          flyoutOrder.push(ADDITIONAL_USER_INPUTS_PAGE);
        }
        const currentFlyoutIndex = flyoutOrder.indexOf(page);
        const nextFlyout = currentFlyoutIndex >= 0 ? flyoutOrder[currentFlyoutIndex + 1] : undefined;
        if (nextFlyout) {
          dispatch(OPEN_DRAWER_PAGE(nextFlyout));
        }
      }
    }
    const verifiableFlyouts = [MODULE_SELECTION_PAGE, LOCATION_AND_LOADS_PAGE, RAIL_SYSTEM_PAGE, ADDITIONAL_USER_INPUTS_PAGE]
    function shouldVerifyTheFlyout(page){
      return verifiableFlyouts.includes(page)
    }
    return (
      <div className={isAuroraRackingTypeSM ? 'save-changes-container aurora-sm' : 'save-changes-container'}>
          {
          shouldVerifyTheFlyout(page) ? 
          <div className='inputs-verified-container'>
            <Checkbox className={'save-changes-button'} label='' id={page} name={page} checked={verifiedFlyouts[page]?.checked} disabled={verifiedFlyouts[page]?.error} onChange={() => verifyInputs(!verifiedFlyouts[page]?.checked)}/>
            <div id='save-changes' className={"save-changes-button"} onClick={!verifiedFlyouts[page]?.error ? () => verifyInputs(!verifiedFlyouts[page]?.checked) : null}>
            {label || 'INPUTS VERIFIED '}
            {<Tooltip id='verify-inputs-tooltip' content='Correct input results correct design. Please ensure that all the inputs are accurate.' position='right' />}
            </div>
          </div>
          : (!projectEnvConfig?.is_aurora_project && !projectEnvConfig?.is_os_project) ? (
            <div role="button" onClick={onClick} className="save-changes-button">
              <SVG src={require('assets/media/icons/icon_checkbox.svg')} />
              {label || 'SAVE CHANGES'}
            </div>) : null
          }
      </div>
    );
  }
}
